import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import MapSetting from '../entities/mapSetting'

import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'


interface MapSettingState extends ListState<MapSetting>{
    mapSetting:MapSetting
    editMapSetting:MapSetting

}

class MapSettingMutations extends ListMutations<MapSetting>{

}

class MapSettingModule extends ListModule<MapSettingState,any,MapSetting>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<MapSetting>(),
        loading:false,
        editMapSetting:new MapSetting(),
        selectMapSetting:new MapSetting(),
      
    
    
    }
    actions={

        async selectMapSetting(context:ActionContext<MapSettingState,any>,payload:any){
            context.state.editMapSetting=payload.data;
        },
     
        async saveMapSetting(context:ActionContext<MapSettingState,any>,payload:any){
         
        
            let reponse=await Ajax.post('/api/services/app/Setting/SaveMapSetting',payload.data);
          
            let page=reponse.data.result as PageResult<MapSetting>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async updateMapSetting(context:ActionContext<MapSettingState,any>,payload:any){
         
        
            let reponse=await Ajax.put('/api/services/app/Setting/UpdateMapSetting',payload.data);
          
            let page=reponse.data.result as PageResult<MapSetting>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getMapSettings(context:ActionContext<MapSettingState,any>,payload:any){
          
           // context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Setting/GetMapSettings',payload.data);
          
           // context.state.loading=false;
            let page=reponse.data.result as PageResult<MapSetting>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
       
     
   
 
    };
    mutations={
        setCurrentPage(state:MapSettingState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:MapSettingState,pagesize:number){
            state.pageSize=pagesize;
        },
    }
}
const mapSettingModule=new MapSettingModule();
export default mapSettingModule;